import { Autocomplete, Backdrop, Box, Checkbox, Container, IconButton, ListItemText, MenuItem, TableCell, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import ItemRegistraVenda from "components/ItemRegistraVenda";
import ItemRegistraVendaTroca from "components/ItemRegistraVendaTroca";
import FixarDescontoDialog from "components/fixardesconto/FixarDescontoDialog";
import { FloatingActionsProps } from "components/floatingactions/FloatingActions";
import InfiniteScrollVirtuoso, { HeaderInfiniteScrollVirtuosoProps } from "components/infinitescrollvirtuoso/InfiniteScrollVirtuoso";
import ConsumidorInput, { ConsumidorInputComponent } from "components/inputs/consumidorinput/ConsumidorInput";
import SkuInput, { SkuInputComponent } from "components/inputs/skuinput/SkuInput";
import VendedorInput, { VendedorInputComponent } from "components/inputs/vendedorinput/VendedorInput";
import useCatchApiError from "hooks/useCatchApiError";
import useFlowRoles from "hooks/useFlowRoles";
import { useGenerateUuid } from "hooks/useGenerateUuid";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import Footer from "layout/footer/Footer";
import useTabelaPreco from "layout/topbar/tabela-preco";
import { IAbstractModel } from "model/abstract.model";
import { IConsumidor, TipoPessoa } from "model/cliente.model";
import { IToken } from "model/token.model";
import AutorizaDescontoAcrescimo from "pages/Configuracoes/AutorizaDescontoAcrescimo";
import AutorizaDescontoItemError from "pages/Configuracoes/AutorizaDescontoItemError";
import { ConfiguracaoDescontoTO, TipoDescontoAcrescimoAutorizador } from "pages/Configuracoes/Configuracoes.model";
import ConfiguracaoDescontoAcrescimoService from "pages/Configuracoes/configuracao-desconto-acrescimo.service";
import CustomLoading from "pages/Venda/Header/CustomLoading";
import CpfNota, { mascaraCpfCnpj } from "pages/cpfNota/CpfNota";
import ConsultaEstoque from "pages/estoque/ConsultaEstoque";
import LoginService from "pages/login/login.service";
import NotaReferenciadaService from "pages/nota-referenciada/NotaReferenciada.service";
import ValePresenteDialog from "pages/vale-presente/ValePresenteDialog";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetDescontoAutorizador, setCanalVendaPadrao, setConfiguracaoDescontoAutorizador, setDeposito, setTabelaPreco } from "redux/features/configuracoes";
import { persistDescontoFixo, resetDesconto, roolBackDescontoFixo, setDescontoFixoTemp } from "redux/features/descontoFixoSlice";
import { resetChavesReferenciadas } from "redux/features/notaReferenciadaSlice";
import { resetPagamento, setValorBrinde } from "redux/features/pagamentoSlice";
import { addEstoqueItens, addItemDesconto, addSku, addSkuTroca, addSkuTrocaByCupom, atualizarEstoqueItens, atualizaValoresItensPedido, removeEstoqueItens, removeSku, removeSkuTrocaByCupom, removeSkuTrocas, resetDadosFrete, resetDescontoFooter, resetPreferencias, resetSkusConsultados, resetState, setAbstractModel, setCanalVenda, setClientePossuiEnderecoForaEstado, setCpfNota, setDescontoItem, setDescontoItemTroca, setGuias, setObservacao, setOutrosVendedores, setProdutos, setProdutosTroca, setQuantidadeItem, setQuantidadeItemTroca, setVendedorPrincipal, toggleTipoDescontoItem, toggleTipoDescontoItemTroca } from "redux/features/stateSlice";
import { setActiveStep } from "redux/features/stepperSlice";
import { useAppDispatch, useAppSelector } from "redux/hooks";

import CustomProdutoImagensDialog from "components/ProdutoImagem/CustomProdutoImagensDialog";
import { addImagensUuidProduto, addUuidsProdutoProdutoRow, FichaImagemAssociacao } from "redux/features/imagemReducer";
import ProdutoService from "service/produto.service";
import { theme } from "theme";
import useCustomLocation from "utils/useCustomLocation";
import { currencyOf, deepCopy, hasDuplicateObjects, isEmpty, roundHalfToEven, roundToTwoDecimalPlaces } from "utils/util";
import Sound from '../../assets/barcode_error.mp3';
import DialogContext from "../../components/confirm-dialog-context";
import ObservacaoDialog from "./ObservacaoDialog";
import { FlowVendedorDTO, TipoAdicaoVendedor } from "./OutrosComissionados";
import ConfirmacaoExcluirSkuDialog from "./confirmacao-excluir-sku-dialog";
import usePoliticaVendaAlerta from "./politica-venda-alerta";
import { criarProdutoRow } from "./registra-venda-produto-row";
import { getQuantidadeItensBrinde, getValorTotalItensComDesconto, getValorTotalItensSemDesconto } from "./registra-venda-totais";
import { CupomTrocaSkuDTO, headerWidths, IProduto, IProdutoRow, ITrocaRow } from "./registra-venda.model";
import RegistraVendaService from "./registra-venda.service";
import './registra-venda.style.css';
import TabelaPrecoPreferenciaDialog from "./tabela-preco-preferencia-dialog";

const initialState = {
    showModalDescontoItem: false as boolean,
    showModalDescontoNaoAutorizado: false as boolean,
    showLoading: false as boolean,
    brinde: false as boolean,
    canaisDeVenda: [] as Array<IAbstractModel>,
    filtroCanalDeVenda: "" as string,
    shouldOpenPreferenciasDialog: false,
    uuidProduto: null as null | string
};

export const BEEPSOUND = new Audio(Sound);

export default function RegistraVenda() {
    const { pathname } = useLocation();
    const isPreVendaRoute = pathname.includes("pre-venda");
    const { venda: vendaRoles, preVenda: preVendaRoles } = useFlowRoles();
    const isEditingPedido = !!useAppSelector(s => s.state.pedido.numero);
    const pickByFluxo = <T,>(preNovo: T, preEditar: T, vendaNovo: T, vendaEditar: T): T => {
        if (isPreVendaRoute) return isEditingPedido ? preEditar : preNovo;
        return isEditingPedido ? vendaEditar : vendaNovo;
    };
    const canEditarPedido = pickByFluxo(preVendaRoles.canNovoPrevenda, preVendaRoles.canEditarPrevenda, vendaRoles.canNovoPedido, vendaRoles.canEditarPedido);
    const canEditarVendedor = pickByFluxo(preVendaRoles.canNovoPrevenda, preVendaRoles.canEditarPrevenda, vendaRoles.canNovoPedido, vendaRoles.canEditarVendedor);
    const canBrinde = pickByFluxo(preVendaRoles.canNovoBrinde, preVendaRoles.canBrinde, vendaRoles.canNovoBrinde, vendaRoles.canBrinde);
    const canDescontoItem = pickByFluxo(preVendaRoles.canNovoDescontoItem, preVendaRoles.canDescontoItem, vendaRoles.canNovoDescontoItem, vendaRoles.canDescontoItem);
    const canValePresente = pickByFluxo(preVendaRoles.canNovoValePresente, preVendaRoles.canValePresente, vendaRoles.canNovoValePresente, vendaRoles.canValePresente);
    const canObservacao = pickByFluxo(preVendaRoles.canNovoObservacao, preVendaRoles.canObservacao, vendaRoles.canNovoObservacao, vendaRoles.canObservacao);
    const canConsultaEstoque = pickByFluxo(preVendaRoles.canNovoConsultaEstoque, preVendaRoles.canConsultaEstoque, vendaRoles.canNovoConsultaEstoque, vendaRoles.canConsultaEstoque);
    const service = RegistraVendaService();
    const notaReferenciadaService = NotaReferenciadaService();
    const dialog = useContext(DialogContext);
    const { addSuccess, addError, closeSnack } = useSnackbarCustom();
    const { throwErrorMessage } = useCatchApiError();
    const [stateLocal, setStateLocal] = useState(initialState);

    // Refs
    const skuinputRef = useRef<SkuInputComponent>(null);
    const consumidorInputRef = useRef<ConsumidorInputComponent>(null);
    const vendedorInputRef = useRef<VendedorInputComponent>(null);
    const canalVendaPadrao = useAppSelector(e => e.configuracoes.canalVendaPadrao);
    const canalVendaRef = useRef<HTMLInputElement>(null);
    const consumidorAnteriorRef = useRef<IConsumidor | null>(null);
    const consumidorAtualRef = useRef<IConsumidor | null>(null);
    const clientePendenteAlertaPoliticaVendaRef = useRef<IConsumidor | null>(null);

    // State
    const dispatch = useAppDispatch();

    const {
        quantidadeTotal,
        itens: produtos,
        itensTroca: produtosTroca,
        cliente: consumidor,
        vendedorPrincipal,
        outrosVendedores,
        guias,
        cpfNota,
        canalDeVenda,
        tabelaPreco
    } = useAppSelector(s => s.state.pedido);

    const [randomUuid] = useGenerateUuid();
    const configuracaoBalcao = useAppSelector(e => e.configuracoes.configuracaoPedidoBalcao);

    const {
        percentualTemp,
        percentual,
        uuidAutorizador: uuidAutorizadorDescontoFixo
    } = useAppSelector(s => s.descontoFixo);


    const [openFixarDescontoDialog, setOpenFixarDescontoDialog] = useState(false);
    const [openConsultaEstoqueDialog, setOpenConsultaEstoqueDialog] = useState(false);
    const [openObservacao, setOpenObservacao] = useState(false);
    const [openStateValePresenteDialog, setOpenStateValePresenteDialog] = useState(false);
    const navigate = useNavigate();
    const estabelecimento = useAppSelector(e => e.estabelecimentoSelecionado);
    const trocaRef = useRef<{ isVisible: boolean; }>({ isVisible: false });
    const [trocaState, setTrocaState] = useState<{ isVisible: boolean; }>(trocaRef.current);
    const loginService = LoginService();
    const token = useAppSelector(e => e.token);
    const caixa = useAppSelector(s => s.caixa);
    const { descontoMaximoItem, uuid: userConfiguracaoDescontoUUID } = useAppSelector(e => e.configuracoes.configuracaoDesconto);
    const { descontoMaximoItem: descontoMaximoItemAutorizador, descontoMaximoPedido: descontoMaximoPedidoAutorizador, autorizaDesconto: autorizaDescontoAutorizador, uuid: uuidConfiguracaoAutorizador } = useAppSelector(e => e.configuracoes.configuracaoDescontoAutorizador.configuracaoDesconto);
    const rowRef = useRef<string | null>(null);
    const descontoSolicitadoRef = useRef<number | null>(null);
    const configuracaoDescontoService = ConfiguracaoDescontoAcrescimoService();
    const configuracaoDescontoUsuario = useAppSelector(e => e.configuracoes.configuracaoDesconto);
    const { isTelaRegistraVenda, isTelaValePresente, isTelaPagamento } = useCustomLocation();
    const resetRef = useRef<boolean>(false);
    const deveLimparCpfCpnj = useRef(false);

    const preferencias = useAppSelector(s => s.preferencias);
    const [openDialogTabelaPrecoPreferencia, setOpenDialogTabelaPrecoPreferencia] = useState(false);
    const { dadosAlterarTabelaPrecoState, setDadosAlterarTabelaPrecoState } = useTabelaPreco();
    const { verificarAlertaPoliticaVenda } = usePoliticaVendaAlerta();

    useEffect(() => {
        if (consumidorAnteriorRef.current === consumidorAtualRef.current || !preferencias) return setOpenDialogTabelaPrecoPreferencia(false);
        if (stateLocal.shouldOpenPreferenciasDialog && !!preferencias.tabelasPreco?.length) {
            setStateLocal(prev => ({ ...prev, shouldOpenPreferenciasDialog: false }));
            setOpenDialogTabelaPrecoPreferencia(true);
        } else if (preferencias.tabelasPreco && preferencias.tabelasPreco.length === 1) {
            dispatch(setTabelaPreco(preferencias.tabelasPreco[0]));
        }
        //eslint-disable-next-line
    }, [preferencias, stateLocal.shouldOpenPreferenciasDialog]);

    const onConfirmModalSkus = () => {
        dispatch(atualizaValoresItensPedido(dadosAlterarTabelaPrecoState.data));
        if (dadosAlterarTabelaPrecoState.tabelaPrecoTemp && tabelaPreco) {
            dispatch(setTabelaPreco(tabelaPreco));
        }
        setDadosAlterarTabelaPrecoState(prevState => ({
            ...prevState,
            showConfirmaExclusao: false,
            produtosParaExcluir: [],
            tabelaPrecoTemp: null,
            data: [],
            length: 0
        }));
    };

    const onOpenImage = useCallback((uuidProduto: string) => {
        setStateLocal(prevState => ({ ...prevState, uuidProduto }));
    }, []);

    const onCloseImagensProduto = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, uuidProduto: null }));
    }, []);

    const {
        imagens
    } = useAppSelector(e => e.imagens);

    useEffect(() => {
        dispatch(addUuidsProdutoProdutoRow([...produtos, ...produtosTroca]));
        //eslint-disable-next-line
    }, [produtos.length, produtosTroca.length]);

    const produtoService = ProdutoService();

    const setImagens = useCallback(async (toSearch: Array<string>) => {
        try {
            const { data } = await produtoService.getImagensProdutoFull(toSearch);
            dispatch(addImagensUuidProduto(data));
        } catch (err) {
            throwErrorMessage(err ?? []);
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        const toSearch: Array<string> = imagens.filter(e => isEmpty(e.imagens)).map(e => e.uuidProduto);
        if (!isEmpty(toSearch)) {
            setImagens(toSearch);
        }
        //eslint-disable-next-line
    }, [imagens.length]);



    const fixedHeaderContent = ({ calcWidth }: Omit<HeaderInfiniteScrollVirtuosoProps<any>, 'columns'>) => {
        return (
            <TableRow sx={{
                width: '100%',
            }}>
                <TableCell colSpan={2}
                    sx={{
                        width: calcWidth(headerWidths.produtoVenda, 15),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        textAlign: 'left',
                        padding: 0,
                        paddingLeft: '15px',
                        color: theme.palette.common.black
                    }}
                >
                    Produto da venda{produtosTroca.length > 0 ? "/troca" : ""}
                </TableCell>
                {/* <TableCell
                    sx={{
                        minWidth: headerWidths.estoque,
                        maxWidth: headerWidths.estoque,
                        width: headerWidths.estoque,
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        padding: 0,
                        paddingLeft: '10px',
                        color: theme.palette.common.black
                    }}
                    align="center"
                >
                    Estoque
                </TableCell> */}
                <TableCell
                    sx={{
                        width: calcWidth(headerWidths.quantidade),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        padding: 0,
                        color: theme.palette.common.black
                    }}
                    align="center"
                >
                    Quantidade
                </TableCell>
                <TableCell
                    sx={{
                        width: calcWidth(headerWidths.valorUnitario),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        padding: 0,
                        color: theme.palette.common.black
                    }}
                    align="center"
                >
                    Valor unitário
                </TableCell>
                <TableCell
                    sx={{
                        width: calcWidth(headerWidths.desconto),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        padding: 0,
                        color: theme.palette.common.black
                    }}
                    align="center"
                >
                    Desconto
                </TableCell>

                <TableCell
                    sx={{
                        width: calcWidth(headerWidths.total),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        padding: 0,
                        color: theme.palette.common.black
                    }}
                    align="center"
                >
                    Total
                </TableCell>

                <TableCell
                    sx={{
                        width: calcWidth(headerWidths.brinde),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        color: theme.palette.common.black
                    }}
                    align="right"
                >
                </TableCell>
                <TableCell
                    sx={{
                        width: calcWidth(headerWidths.lixeira),
                        bgcolor: theme.palette.background.default,
                        fontWeight: '600',
                        fontSize: '14px',
                        color: theme.palette.common.black
                    }}
                    align="right"
                >
                </TableCell>
            </TableRow>
        );
    };

    const fixedFooterContent = () => {
        return (
            <TableRow className="glassmorphism">

                <TableCell colSpan={2}
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                >
                    <span className="footerText">Total da venda</span>
                </TableCell>

                {/* <TableCell className="glassmorphism"
                    sx={{
                        minWidth: headerWidths.estoque,
                        maxWidth: headerWidths.estoque,
                        width: headerWidths.estoque,
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                /> */}

                <TableCell
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                >
                    <span className="footerText">{quantidadeTotal + (configuracaoBalcao.somarValorBrindeTotalNota ? getQuantidadeBrindes() : 0)}</span>
                </TableCell>

                <TableCell
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                >
                    <span className="footerText">{currencyOf(getValorTotalSemDesconto())}</span>
                </TableCell>

                <TableCell
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                />

                <TableCell
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                >
                    <span className="footerText">{currencyOf(getValorTotalComDesconto())}</span>
                </TableCell>

                <TableCell
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                />

                <TableCell
                    sx={{
                        padding: "15px",
                        borderLeft: 0,
                        borderRight: 0,
                    }}
                    align="center"
                />
            </TableRow>
        );
    };

    const resetFocus = useCallback(() => {
        skuinputRef.current?.focus();
    }, []);

    const {
        pedido,
        bloqueiaVendaContaReceberVencida,
        bloqueiaVendaConsignadoEmAndamento,
        verificandoAlertaPoliticaVenda
    } = useAppSelector(s => s.state);

    const onClickAvancar = () => {

        if (verificandoAlertaPoliticaVenda) {
            return addError({ id: 'erro-verificando-politica-venda', message: 'Aguarde a validação do cliente selecionado.', closeable: true, preventDuplicate: true });
        }
        if (bloqueiaVendaContaReceberVencida) {
            return addError({ id: 'erro-bloqueio-conta-receber-vencida', message: 'Cliente possui contas a receber vencidas.', closeable: true, preventDuplicate: true });
        }
        if (bloqueiaVendaConsignadoEmAndamento) {
            return addError({ id: 'erro-bloqueio-consignado-em-andamento', message: 'Cliente possui consignado em andamento.', closeable: true, preventDuplicate: true });
        }
        if (pedido.itensTroca.length && !pedido.cliente?.uuid) {
            consumidorInputRef.current?.focus();
            return addError({ id: "erro-troca-sem-cliente", message: "Para realizar troca, é obrigatório informar cliente!", closeable: true, preventDuplicate: true });
        }
        if (!pedido.cliente && !configuracaoBalcao.serieFiscalNFCe) {
            consumidorInputRef.current?.focus();
            return addError({ id: "erro-sem-serie-nfce", message: "Série padrão para NFC-e não configurada. Obrigatório informar cliente!", closeable: true, preventDuplicate: true });
        }
        if (pedido.itens.some(e => e.quantidade > e.estoque)) {
            return addError({ id: "erro_estoque_quantidade", message: "A quantidade do produto não pode ser maior que o estoque!", closeable: true, preventDuplicate: true });
        }
        if (!pedido.itens.length) {
            return addError({ id: 'erro-semproduto', message: 'Selecione ao menos um produto para continuar', closeable: true, preventDuplicate: true });
        }
        if (pedido.valorTotalBruto < pedido.valorTotalLiquidoTroca) {
            return addError({ id: 'erro-valor-venda-inferior-troca', message: 'Valor da venda não pode ser inferior a devolução', closeable: true, preventDuplicate: true });
        }
        if ((pedido.valorTotalLiquido - pedido.valorTotalLiquidoTroca) < 0) {
            return addError({ id: 'erro-valor-venda-inferior-troca', message: 'Valor do total à pagar não pode ser inferior a 0', closeable: true, preventDuplicate: true });
        }
        if (!pedido.valorTotalLiquidoTroca && pedido.pedidoDescontoAcrescimo.percentualDesconto === 100) {
            return addError({ id: 'erro-pedido-valor-deve-ser-maior-0', message: 'Valor minimo de pedido somente venda deve ser R$ 0,01', closeable: true, preventDuplicate: true });
        }
        if (isCaixaObrigaVendedor() && !pedido.vendedorPrincipal) {
            vendedorInputRef.current?.focus();
            return addError({ id: 'erro-vendedor-brigatorio', message: 'Para este caixa, vendedor é obrigatório', closeable: true, preventDuplicate: true });
        }
        if (!pedido.vendedorPrincipal && !!guias.length) {
            vendedorInputRef.current?.focus();
            return addError({ id: 'erro-possui-guias-sem-vendedor-principal', message: 'Selecione um vendedor ou remova os outros vendedores', closeable: true, preventDuplicate: true });
        }
        if (pedido.itens.some(e => e.brinde) && pedido.itensTroca.length > 0) {
            const valorBrindes = pedido.itens.filter(e => e.brinde).reduce((prev, act) => prev + act.valorTotal, 0);
            const total = roundToTwoDecimalPlaces(roundHalfToEven(pedido.valorTotalLiquido - valorBrindes - pedido.valorTotalLiquidoTroca, 2));
            if (total < 0) return addError({ id: 'erro-valor-venda-inferior-troca-com-brinde', message: 'Valor da venda não pode ser inferior a devolução', closeable: true, preventDuplicate: true });
        }

        const pedidoIsBrinde = pedido.itens.every(item => item.brinde);
        if (!pedido.cliente && pedidoIsBrinde) {
            return addError({ id: 'erro-brinde-sem-consumidor', message: 'Brinde não é permitido para pedido sem cliente', closeable: true, preventDuplicate: true });
        }


        return navigate('/pagamento');
    };

    const onClickCancelar = () => {
        const canCreateNew = isPreVendaRoute ? preVendaRoles.canNovo : vendaRoles.canNovo;
        const shouldNavigateBack = isEditingPedido && !canCreateNew;

        const doReset = () => {
            dispatch(resetDescontoAutorizador());
            dispatch(resetDesconto());
            dispatch(resetState());
            dispatch(resetPagamento());
            if (configuracaoBalcao.tabelaPrecoPadrao) {
                dispatch(setTabelaPreco(configuracaoBalcao.tabelaPrecoPadrao));
            }
            if (configuracaoBalcao.deposito) {
                dispatch(setDeposito(configuracaoBalcao.deposito));
            }
            dispatch(resetPreferencias());
            if (shouldNavigateBack) navigate(-1);
        };

        if (isEmpty(pedido.itens)) {
            doReset();
        } else {
            dialog.confirm({
                title: 'Atenção',
                message: `Ao cancelar, todos os dados serão perdidos. Deseja cancelar?`,
                onConfirm: doReset,
            });
        }
    };

    const clickBrinde = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, brinde: !prevState.brinde }));
    }, []);

    const floatingActions: FloatingActionsProps = {
        actions: [
            {
                label: 'Fixar desconto (Alt + M)',
                icon: 'fa-regular fa-percent',
                disabled: () => !canDescontoItem,
                onClick: () => {
                    setOpenFixarDescontoDialog(true);
                }
            },
            {
                label: 'Consulta estoque (Alt + E)',
                icon: 'fa-solid fa-boxes-stacked',
                disabled: () => !canConsultaEstoque,
                onClick: () => {
                    setOpenConsultaEstoqueDialog(true);
                }
            },
            {
                label: 'Brinde (Alt + B)',
                icon: 'fa-solid fa-gifts',
                disabled: () => !canBrinde,
                onClick: clickBrinde
            },
            {
                label: 'Adicionar observação (Alt + O)',
                icon: 'fa-solid fa-pen-to-square',
                disabled: () => !canObservacao,
                onClick: () => {
                    setOpenObservacao(true);
                }
            },
            {
                label: 'Vale presente (Alt + V)',
                icon: 'fa-solid fa-gift',
                disabled: () => !canValePresente || !!produtos.length || !!produtosTroca.length,
                onClick: () => {
                    if (!isTelaPagamento() && !isTelaValePresente() && (produtos.length === 0 || produtosTroca.length === 0)) {
                        setOpenStateValePresenteDialog(true);
                    }
                }
            },
        ]
    };

    const handleKeyNavigate = (e: KeyboardEvent) => {
        switch (e.key) {
            case 'Escape':
                if (trocaRef.current.isVisible) {
                    trocaRef.current.isVisible = false;
                    toogleTroca(false);
                } else {
                    onClickCancelar();
                }
                break;
            case 'Enter':
                if (e.ctrlKey) {
                    e.preventDefault();
                    onClickAvancar();
                }
                break;
        }
    };


    const handleKeyDown = (e: KeyboardEvent) => {
        switch (e.key) {
            case 'F3':
                e.preventDefault();
                handleClickOpenDialog();
                break;
            case "m":
            case "M":
                if (e.altKey && canDescontoItem) {
                    e.preventDefault();
                    setOpenFixarDescontoDialog(true);
                }
                break;
            case 't':
            case "T":
                if (isTelaRegistraVenda() && e.altKey) {
                    e.preventDefault();
                    toogleTroca(!trocaRef.current.isVisible);
                    trocaRef.current.isVisible = !trocaRef.current.isVisible;
                    resetFocus();
                }
                break;
            case "e":
            case "E":
                if (e.altKey && canConsultaEstoque) {
                    e.preventDefault();
                    setOpenConsultaEstoqueDialog(() => !openConsultaEstoqueDialog);
                }
                break;
            case "b":
            case "B":
                if (isTelaRegistraVenda() && e.altKey) {
                    e.preventDefault();
                    setStateLocal(prevState => ({ ...prevState, brinde: !prevState.brinde }));
                }
                break;

            case "o":
            case "O":
                if (e.altKey && canObservacao) {
                    e.preventDefault();
                    setOpenObservacao(true);
                }
                break;
            case "v":
            case "V":
                if (canValePresente && !isTelaPagamento() && !isTelaValePresente() && (produtos.length === 0 || produtosTroca.length === 0) && e.altKey) {
                    e.preventDefault();
                    setOpenStateValePresenteDialog(true);
                }
                break;
            case 'F10':
                e.preventDefault();
                canalVendaRef.current && canalVendaRef.current.focus();
                break;
        }
    };

    const getCanaisVenda = useCallback(async () => {
        try {
            const { data } = await service.getCanaisVenda();
            setStateLocal(prevState => ({
                ...prevState,
                canaisDeVenda: data
            }));
        } catch (err) {
            throwErrorMessage(err ?? []);
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyNavigate);
        return () => {
            window.removeEventListener('keydown', handleKeyNavigate);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pedido.itens]);

    useEffect(() => {
        dispatch(setActiveStep(0));
        resetFocus();
        getCanaisVenda();

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fazerAsParadasDeNotaReferenciada = (
        value: IConsumidor,
        produtosTroca: ITrocaRow[]
    ) => {
        // Itens lidos por cupom de troca já sabem exatamente qual nota fiscal
        // os originou (setado em addSkuTrocaByCupom) — não entram nessa busca
        // automática por sku, que só encontraria "alguma" nota do cliente com aquele sku.
        const itens = deepCopy(produtosTroca).filter(s => !s.cupomTroca);
        if (!itens.length) {
            shouldConsultaNotaReferenciada.current = true;
            return;
        }
        const toPost: Record<string, number> = {};
        itens.forEach(s => {
            const skuUUID = s.produto.uuid;
            if (!toPost[skuUUID]) {
                toPost[skuUUID] = 0;
            }
            toPost[skuUUID] = roundHalfToEven(toPost[skuUUID] + s.quantidade, 0);
        });
        notaReferenciadaService
            .getNotas(value.uuid, toPost)
            .then(({ data }) => {
                if (!data) return limparNotasReferenciadas(produtosTroca);
                const copyResponse = deepCopy(data);
                const copyItens = deepCopy(itens);
                copyItens.forEach(item => {
                    const skuUUID = item.produto.uuid;
                    const notaInfo = copyResponse[skuUUID];
                    item.notaReferenciadaInfo = {
                        notas: [],
                        quantidadeNaoReferenciada: 0,
                    };
                    let qtdFaltante = item.quantidade;
                    if (!notaInfo) {
                        item.notaReferenciadaInfo!.quantidadeNaoReferenciada = qtdFaltante;
                        return;
                    };
                    notaInfo.notas.forEach(nota => {
                        if (!nota) return;
                        const notaSaldo = nota.saldo;
                        if (notaSaldo <= 0 || qtdFaltante <= 0) return;
                        if (item.notaReferenciadaInfo!.notas.every(s => s.chaveAcesso !== nota.chaveAcesso)) {
                            item.notaReferenciadaInfo!.notas.push(deepCopy(nota));

                        }
                        nota.saldo -= qtdFaltante;
                        qtdFaltante -= notaSaldo;
                    });
                    if (qtdFaltante > 0) {
                        item.notaReferenciadaInfo!.quantidadeNaoReferenciada = qtdFaltante;
                    }
                });

                const atualizadosPorUuid = new Map(copyItens.map(item => [item.uuid, item]));
                const merged = produtosTroca.map(item => atualizadosPorUuid.get(item.uuid) ?? item);
                dispatch(setProdutosTroca(deepCopy(merged)));
            }).finally(() => {
                shouldConsultaNotaReferenciada.current = true;
            });
    };

    const limparNotasReferenciadas = (produtosTroca: ITrocaRow[]) => {
        if (!produtosTroca.length) return;
        const copyTroca = deepCopy(produtosTroca);
        copyTroca.forEach(s => { if (!s.cupomTroca) s.notaReferenciadaInfo = undefined; });
        dispatch(setProdutosTroca(copyTroca));
        dispatch(resetChavesReferenciadas());
    };

    const onSelectConsumidor = useCallback((value: IConsumidor | null) => {
        if ((value?.uuid ?? null) === (pedido.cliente?.uuid ?? null)) {
            return;
        }
        if ((!value || value !== consumidorAnteriorRef.current) && configuracaoBalcao.tabelaPrecoPadrao && !preferencias.tabelasPreco) {
            dispatch(setTabelaPreco(configuracaoBalcao.tabelaPrecoPadrao));
        }

        setStateLocal(prev => ({ ...prev, shouldOpenPreferenciasDialog: true }));

        if (value !== consumidorAnteriorRef.current) {
            if (consumidorAtualRef.current?.uuid !== value?.uuid) {
                consumidorAnteriorRef.current = consumidorAtualRef.current;
                consumidorAtualRef.current = value;
            }
        }
        dispatch(setAbstractModel({ propertieName: 'cliente', obj: value }));
        const deveAbrirCpfNota = consumidorAnteriorRef.current !== consumidorAtualRef.current
            && !!value?.identificacao && value.tipoPessoa !== TipoPessoa.ESTRANGEIRA;
        if (deveAbrirCpfNota) {
            dispatch(setCpfNota({ identificacao: value?.identificacao, nome: value?.nome }));
            handleClickOpenDialog();
        }

        if (!!value) {
            const consumidor = value as IConsumidor | null;
            const reps = consumidor?.representantes ?? [];
            if (reps.length === 1) {
                const found = vendedorInputRef.current?.allVendedores.find(s => s.uuid === reps[0]);
                if (!!found) {
                    onSelectVendedor(found);
                }
            }
            addGuiasLocal(value.guias ?? []);
            if (deveAbrirCpfNota) {
                clientePendenteAlertaPoliticaVendaRef.current = value;
            } else {
                verificarAlertaPoliticaVenda(value);
            }
        } else {
            onSelectVendedor(null);
            dispatch(setOutrosVendedores([]));
            dispatch(setGuias([]));
        }

        if (value != null) deveLimparCpfCpnj.current = false;
        //eslint-disable-next-line
    }, [vendedorPrincipal, outrosVendedores, guias, configuracaoBalcao.caixasObrigaVendedor, caixa]);

    const shouldConsultaNotaReferenciada = useRef<boolean>(true);
    const { chavesAcesso } = useAppSelector(s => s.notaReferenciada);

    useEffect(() => {
        if (shouldConsultaNotaReferenciada.current && !consumidor) {
            shouldConsultaNotaReferenciada.current = false;
            limparNotasReferenciadas(produtosTroca);
            setTimeout(() => {
                shouldConsultaNotaReferenciada.current = true;
            },);
        }

        if (shouldConsultaNotaReferenciada.current && consumidor && chavesAcesso.length) {
            shouldConsultaNotaReferenciada.current = false;
            const copyItensTroca = deepCopy(produtosTroca);
            copyItensTroca.forEach(s => {
                if (s.cupomTroca) return;
                if (!s.notaReferenciadaInfo) {
                    s.notaReferenciadaInfo = {
                        notas: [],
                        quantidadeNaoReferenciada: 0
                    };
                }

                s.notaReferenciadaInfo!.notas = chavesAcesso.map(n => ({
                    chaveAcesso: n.chaveAcesso,
                    serie: n.serie,
                    numeroNota: n.numero,
                    saldo: 0,
                    skuUUID: s.produto.uuid,
                }));
                s.notaReferenciadaInfo!.quantidadeNaoReferenciada = s.quantidade;
            });

            dispatch(setProdutosTroca(copyItensTroca));
            setTimeout(() => {
                shouldConsultaNotaReferenciada.current = true;
            },);
            return;
        }

        if (shouldConsultaNotaReferenciada.current && produtosTroca.length && consumidor) {
            shouldConsultaNotaReferenciada.current = false;
            setTimeout(() => {
                fazerAsParadasDeNotaReferenciada(consumidor, produtosTroca);
            },);
        }
        //eslint-disable-next-line
    }, [produtosTroca, consumidor, chavesAcesso]);


    const onSelectVendedor = useCallback((value: FlowVendedorDTO | null) => {
        dispatch(setVendedorPrincipal(value));
        if (!!value) {
            const outrosComissionados = value.outrosComissionados ?? [];
            setOutrosComissionados(outrosComissionados, TipoAdicaoVendedor.OUTRO_COMISSIONADO, value);
        } else {
            dispatch(setOutrosVendedores(outrosVendedores.filter(s => s.tipoAdicao === TipoAdicaoVendedor.REPRESENTANTE)));
        };
        //eslint-disable-next-line
    }, [consumidor, outrosVendedores]);

    const onInputChangeCanalVendaAc = useCallback((event: any, value: string) => {
        if (!value && event && event.type === "change") {
            dispatch(setCanalVenda(null));
            return setStateLocal(prevState => ({ ...prevState, filtroCanalDeVenda: initialState.filtroCanalDeVenda }));
        }
        if (value && event && event.type === "change") {
            return setStateLocal(prevState => ({ ...prevState, filtroCanalDeVenda: value }));
        }
        if (event && event.type === "click") {
            dispatch(setCanalVenda(null));
            return setStateLocal(prevState => ({ ...prevState, filtroCanalDeVenda: initialState.filtroCanalDeVenda }));

        }
        //eslint-disable-next-line
    }, []);

    const setOutrosComissionados = (uuids: string[], tipoAdicao: TipoAdicaoVendedor, vendedor: FlowVendedorDTO | null = vendedorPrincipal) => {
        const todos = vendedorInputRef.current?.allVendedores ?? [];
        const toAdd = uuids.map(uuid => ({
            ...todos.filter(v => v.uuid === uuid)[0],
            tipoAdicao,
        }));
        const { itensChecados } = hasDuplicateObjects(
            [...toAdd, ...outrosVendedores],
            (a, b) => a.uuid === b.uuid
        );
        const toSet = itensChecados.filter(s => s.uuid !== vendedor?.uuid);

        dispatch(setOutrosVendedores(toSet));
    };

    const addGuiasLocal = (guias: string[]) => {
        const todos = vendedorInputRef.current?.allVendedores ?? [];
        const guiasToSet = (guias ?? []).map(uuid => ({
            ...todos.filter(v => v.uuid === uuid)[0],
            tipoAdicao: TipoAdicaoVendedor.GUIA,
        }));
        dispatch(setGuias(guiasToSet));
    };

    const uuidAutorizadorDescontoFixoEfetivo =
        percentual > 0 ? uuidAutorizadorDescontoFixo ?? userConfiguracaoDescontoUUID : null;

    const onSelectProduto = useCallback((value: IProduto | null, isAdding: boolean) => {
        if (!value) return;
        if (!isAdding && !trocaState.isVisible) return dispatch(removeSku(produtoRowOf(value, percentual, uuidAutorizadorDescontoFixoEfetivo, stateLocal.brinde, trocaState.isVisible)));
        if (!isAdding && trocaState.isVisible) return dispatch(removeSkuTrocas(produtoRowOf(value, percentual, uuidAutorizadorDescontoFixoEfetivo, stateLocal.brinde, trocaState.isVisible)));
        if (!trocaState.isVisible) return dispatch(addSku(produtoRowOf(value, percentual, uuidAutorizadorDescontoFixoEfetivo, stateLocal.brinde, trocaState.isVisible)));
        return dispatch(addSkuTroca(produtoRowOf(value, percentual, uuidAutorizadorDescontoFixoEfetivo, stateLocal.brinde, trocaState.isVisible)));
        //eslint-disable-next-line
    }, [trocaState, percentual, uuidAutorizadorDescontoFixoEfetivo, stateLocal.brinde]);

    const onSelectCupomTroca = useCallback((cupom: CupomTrocaSkuDTO, isAdding: boolean) => {
        dispatch(isAdding ? addSkuTrocaByCupom(cupom) : removeSkuTrocaByCupom(cupom));
        //eslint-disable-next-line
    }, []);

    const onSelectCanalVenda = useCallback((value: IAbstractModel | null) => {
        dispatch(setCanalVenda(value));
        //eslint-disable-next-line
    }, []);

    const onSetCanalVendaPadrao = useCallback(async (uuid: string) => {
        try {
            const { data } = await service.setCanalVendaPadrao(uuid);
            if (!!data) {
                dispatch(setCanalVenda(data));
                dispatch(setCanalVendaPadrao(data));
                return;
            }
            dispatch(setCanalVenda(null));
            dispatch(setCanalVendaPadrao(null));

        } catch (err) {
            throwErrorMessage(err ?? []);
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!canalDeVenda && !!canalVendaPadrao) {
            dispatch(setCanalVenda(canalVendaPadrao));
        }
        //eslint-disable-next-line
    }, []);

    const onSelectCanalVendaPadrao = useCallback((option: IAbstractModel) => {
        onSetCanalVendaPadrao(option.uuid);
        //eslint-disable-next-line
    }, []);


    // Produto
    useEffect(() => {
        if (produtos.length) return atualizarEstoque();
        dispatch(resetSkusConsultados());
        dispatch(resetDadosFrete());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [produtos.length]);

    useEffect(() => {
        if (produtos.length) atualizarEstoque();
        // eslint-disable-next-line
    }, [configuracaoBalcao.deposito]);

    useEffect(() => {
        if (deveLimparCpfCpnj.current && !consumidor && cpfNota !== null) {
            dispatch(setCpfNota(null));
        };

        if (consumidor) {
            notaReferenciadaService.clientePossuiEnderecoPrincipalOuEntregaForaDoEstado(consumidor.uuid)
                .then(({ data }) => {
                    dispatch(setClientePossuiEnderecoForaEstado(data.possuiEnderecoForaDoEstado));
                });
        } else {
            dispatch(setClientePossuiEnderecoForaEstado(false));
        }
        //eslint-disable-next-line
    }, [consumidor]);

    const getValorBrindes = useCallback(() => {
        return produtos.filter(e => e.brinde).reduce((_, act) => _ += act.valorTotal, 0);
        //eslint-disable-next-line
    }, [produtos]);

    useEffect(() => {
        dispatch(setValorBrinde(getValorBrindes()));

        if (!resetRef.current && produtos.every(e => e.brinde)) {
            resetRef.current = true;
            dispatch(resetDescontoFooter());
        }
        else resetRef.current = false;

        //eslint-disable-next-line
    }, [produtos]);

    const atualizarEstoque = () => {
        const uuidsNaoConsultados = produtos
            .filter((produto) => !pedido.consultados.includes(produto.produto.uuid))
            .map((produto) => produto.produto.uuid);
        if (!!uuidsNaoConsultados.length) {
            service.getEstoque(uuidsNaoConsultados)
                .then(({ data }) => {
                    dispatch(addEstoqueItens({ itens: data }));
                })
                .catch(throwErrorMessage);
        } else {
            dispatch(atualizarEstoqueItens());
        }
    };

    const produtoRowOf = useCallback((p: IProduto, percentualDescontoFixo: number, uuidAutorizadorDesconto: string | null, brinde: boolean, isTroca: boolean): IProdutoRow => {
        return criarProdutoRow(p, percentualDescontoFixo, uuidAutorizadorDesconto, brinde, isTroca, configuracaoBalcao.somarValorBrindeTotalNota, randomUuid());
        //eslint-disable-next-line
    }, [configuracaoBalcao.somarValorBrindeTotalNota]);

    const toggleTipoDesconto = useCallback((uuid: string) => {
        dispatch(toggleTipoDescontoItem({ uuid }));
        //eslint-disable-next-line
    }, []);

    const toggleTipoDescontoTroca = useCallback((uuid: string) => {
        dispatch(toggleTipoDescontoItemTroca({ uuid }));
        //eslint-disable-next-line
    }, []);

    const tempDescontoItemRef = useRef<number>(0);
    const tempDescIndexRef = useRef<string | null>(null);

    const saveTempDesconto = useCallback((prevDesconto: number, uuid: string) => {
        tempDescontoItemRef.current = prevDesconto;
        tempDescIndexRef.current = uuid;
    }, []);

    const isDescontoLinhaRef = useRef<boolean>(true);

    const onBlurDescontoItem = useCallback((value: number, uuid: string) => {
        if (configuracaoDescontoUsuario.uuid == null) return;

        isDescontoLinhaRef.current = true;
        rowRef.current = uuid;
        descontoSolicitadoRef.current = value;

        if (value <= descontoMaximoItem) {
            dispatch(addItemDesconto({
                uuid: uuid,
                itemDesconto: {
                    uuidAutorizador: userConfiguracaoDescontoUUID,
                    percentualDesconto: descontoSolicitadoRef.current,
                    tipoDesconto: produtos.find(e => e.uuid === uuid)!.itemDesconto.tipoDesconto,
                    valorDesconto: produtos.find(e => e.uuid === uuid)!.itemDesconto.valorDesconto
                }
            }));
        }

        if (descontoMaximoItemAutorizador && value <= descontoMaximoItemAutorizador && autorizaDescontoAutorizador) return;
        if (percentual > 0 && value <= percentual && produtos.find(e => e.uuid === uuid)?.itemDesconto.uuidAutorizador != null) return;
        if (value <= tempDescontoItemRef.current) {
            tempDescontoItemRef.current = 0;
            return;
        }
        if ((value > descontoMaximoItem)) {
            configuracaoDescontoService.validaDescontoSolicitado(value, TipoDescontoAcrescimoAutorizador.DESCONTO_ITEM)
                .then(({ data }: { data: boolean; }) => {
                    if (!data) return setStateLocal(prevState => ({
                        ...prevState,
                        showModalDescontoItem: false,
                        showModalDescontoNaoAutorizado: true
                    }));
                    return setStateLocal(prevState => ({ ...prevState, showModalDescontoItem: true }));
                })
                .catch(() => { });
        }
        //eslint-disable-next-line
    }, [produtos.length, percentual, descontoMaximoItem, descontoMaximoItemAutorizador, autorizaDescontoAutorizador]);

    const changeDesconto = useCallback((value: number, uuid: string) => {
        dispatch(setDescontoItem({ uuid, value }));
        //eslint-disable-next-line
    }, []);

    const changeDescontoTroca = useCallback((value: number, uuid: string) => {
        dispatch(setDescontoItemTroca({ uuid, value }));
        //eslint-disable-next-line
    }, []);


    const onChangeQuantidade = useCallback((uuid: string, value: string) => {
        if (value.startsWith('-')) value = value.substring(1);
        if (!value || value === '0') value = '1';

        dispatch(setQuantidadeItem({ uuid, quantidade: Math.trunc(Number(value)) }));
        //eslint-disable-next-line
    }, []);

    const onChangeQuantidadeTroca = useCallback((uuid: string, value: string) => {
        if (value.startsWith('-')) value = value.substring(1);
        if (!value) value = '1';
        dispatch(setQuantidadeItemTroca({ uuid, quantidade: Math.trunc(Number(value)) }));
        //eslint-disable-next-line
    }, []);



    const toDeleteRowIndex = useRef<string | null>(null);

    const onClickDelete = useCallback((uuid: string, row: IProdutoRow) => {
        dialog.confirm({
            title: 'Atenção',
            message: `Deseja excluir o produto ${row.produto.nome} ?`,
            onConfirm: () => {
                toDeleteRowIndex.current = uuid;
                const rows = produtos.filter(e => e.uuid !== uuid);
                dispatch(removeEstoqueItens(row));
                dispatch(setProdutos(rows));
            }
        });
        //eslint-disable-next-line
    }, [produtos]);

    const onClickDeleteTroca = useCallback((uuid: string, nomeProduto: string) => {
        dialog.confirm({
            title: 'Atenção',
            message: `Deseja excluir o produto ${nomeProduto} ?`,
            onConfirm: () => {
                const rows = produtosTroca.filter((row) => row.uuid !== uuid);
                dispatch(setProdutosTroca(rows));
            }
        });
        //eslint-disable-next-line
    }, [produtosTroca.length]);

    const getValorTotalSemDesconto = () => getValorTotalItensSemDesconto(produtos, configuracaoBalcao.somarValorBrindeTotalNota);

    const getValorTotalComDesconto = () => getValorTotalItensComDesconto(produtos, configuracaoBalcao.somarValorBrindeTotalNota);

    const getHasSomeoneCanGiveDiscount = useCallback((value: number) => {
        configuracaoDescontoService.validaDescontoSolicitado(descontoSolicitadoRef.current!, TipoDescontoAcrescimoAutorizador.DESCONTO_ITEM)
            .then(({ data }: { data: boolean; }) => {
                isDescontoLinhaRef.current = false;
                setOpenFixarDescontoDialog(false);
                if (!data) {
                    return setStateLocal(prevState => ({ ...prevState, showModalDescontoNaoAutorizado: true }));
                }
                descontoSolicitadoRef.current = value;
                return setStateLocal(prevState => ({ ...prevState, showModalDescontoItem: true }));
            })
            .catch(err => {
                addError({ id: "", message: "Não foi possivel validar o desconto, tente novamente. Se o erro persistir, contate o suporte.", closeable: true, persist: false, preventDuplicate: false });
            });
        // eslint-disable-next-line
    }, []);

    const onChangeDescontoFixo = useCallback((value: number = 0) => {
        descontoSolicitadoRef.current = value;
        dispatch(setDescontoFixoTemp(value));
        //eslint-disable-next-line
    }, []);

    const onClearDescontoFixo = useCallback(() => {
        dispatch(setDescontoFixoTemp(0));
        //eslint-disable-next-line
    }, []);

    const onCloseFixarDescontoDialog = useCallback(() => {
        dispatch(roolBackDescontoFixo());
        setOpenFixarDescontoDialog(false);
        resetFocus();
        //eslint-disable-next-line
    }, []);

    const getLimiteDescontoItem = () => {
        if (uuidConfiguracaoAutorizador != null && autorizaDescontoAutorizador) {
            return descontoMaximoItemAutorizador;
        }
        return descontoMaximoItem;
    };

    const getUuidAutorizadorDaAlcada = (descontoSolicitado: number) => {
        if (descontoSolicitado <= descontoMaximoItem) return userConfiguracaoDescontoUUID;
        return uuidConfiguracaoAutorizador ?? userConfiguracaoDescontoUUID;
    };

    const onSaveDescontFixo = (descontoSolicitado: number) => {
        descontoSolicitadoRef.current = descontoSolicitado;
        if (configuracaoDescontoUsuario.uuid != null && descontoSolicitado > getLimiteDescontoItem()) {
            return getHasSomeoneCanGiveDiscount(descontoSolicitado);
        }
        dispatch(persistDescontoFixo(getUuidAutorizadorDaAlcada(descontoSolicitado)));
        setOpenFixarDescontoDialog(false);
        resetFocus();
    };

    //Cpf na nota
    const [openDialog, setOpenDialog] = useState(false);
    const handleClickOpenDialog = () => {
        return setOpenDialog(true);
    };

    const handleClickCloseDialog = useCallback(() => {
        setOpenDialog(false);
        if (clientePendenteAlertaPoliticaVendaRef.current) {
            const clientePendente = clientePendenteAlertaPoliticaVendaRef.current;
            clientePendenteAlertaPoliticaVendaRef.current = null;
            verificarAlertaPoliticaVenda(clientePendente);
        }
    }, [verificarAlertaPoliticaVenda]);

    const switchOptions = () => {
        consumidorAnteriorRef.current = consumidorAtualRef.current;
        toogleTroca(!trocaState.isVisible);
        trocaRef.current.isVisible = !trocaRef.current.isVisible;
    };

    const isCaixaObrigaVendedor = useCallback((): boolean => {
        return configuracaoBalcao.caixasObrigaVendedor?.some(s => s.uuid === caixa.caixaAtual.caixa?.uuid) ?? false;
    }, [configuracaoBalcao.caixasObrigaVendedor, caixa]);

    const onBlurCanalVenda = () => {

    };

    const filterCanaisVenda = useCallback((options: Array<IAbstractModel>, filtro: string) => {
        if (!filtro) return options;
        return options.filter(e => e.descritivo.toUpperCase().includes(filtro.toUpperCase()));
    }, []);

    const toogleTroca = useCallback((isVisible: boolean) => {
        setTrocaState(prev => ({ ...prev, isVisible }));
    }, []);

    const closeAutorizaDesconto = () => {
        if (isDescontoLinhaRef.current) {
            dispatch(setDescontoItem({ uuid: rowRef.current!, value: 0 }));
            rowRef.current = null;
        }
        setStateLocal(prevState => ({ ...prevState, showModalDescontoItem: false, showModalDescontoNaoAutorizado: false }));

        if (!isDescontoLinhaRef.current) {
            dispatch(roolBackDescontoFixo());
            setOpenFixarDescontoDialog(false);
        }
    };

    const handleAutorizaDesconto = (username: string, password: string, switchBoolean: boolean) => {
        closeSnack('same-user-exception');
        closeSnack('desconto-aplicado-com-sucesso');
        closeSnack('usuario-senha-invalido');
        if (username === token.USER_INFO?.username) {
            return addError({ id: "same-user-exception", message: "Seu usuário não permite este desconto, solicite à um responsável", closeable: true, persist: false });
        }

        setStateLocal(prevState => ({ ...prevState, showLoading: true }));
        let tokenAutorizador = "";

        loginService.loga({ user: username, password: password })
            .then(({ data }: { data: IToken; }) => {
                tokenAutorizador = data.access_token!;
                return configuracaoDescontoService.getConfiguracaoDescontoAutorizador(tokenAutorizador, estabelecimento.uuid);
            })
            .then(({ data }: { data: ConfiguracaoDescontoTO; }) => {
                if (isDescontoLinhaRef.current) {
                    dispatch(addItemDesconto({
                        uuid: rowRef.current!,
                        itemDesconto: {
                            uuidAutorizador: data.uuid,
                            percentualDesconto: descontoSolicitadoRef.current!,
                            tipoDesconto: produtos.find(e => e.uuid === rowRef.current!)!.itemDesconto.tipoDesconto,
                            valorDesconto: produtos.find(e => e.uuid === rowRef.current!)!.itemDesconto.valorDesconto

                        }
                    }));
                }
                if (switchBoolean) {
                    dispatch(setConfiguracaoDescontoAutorizador({
                        token: tokenAutorizador,
                        configuracaoDesconto: {
                            uuid: data.uuid,
                            usuario: data.usuario,
                            descontoMaximoItem: descontoSolicitadoRef.current ?? 0,
                            descontoMaximoPedido: descontoMaximoPedidoAutorizador ?? data.descontoMaximoPedido,
                            acrescimoMaximoPedido: 0,
                            autorizaDesconto: data.autorizaDesconto,
                        }
                    }));
                }
                else {
                    dispatch(setConfiguracaoDescontoAutorizador({
                        token: tokenAutorizador,
                        configuracaoDesconto: {
                            uuid: data.uuid,
                            usuario: data.usuario,
                            descontoMaximoItem: descontoSolicitadoRef.current ?? descontoMaximoItemAutorizador ?? 0,
                            descontoMaximoPedido: descontoMaximoPedidoAutorizador ?? 0,
                            acrescimoMaximoPedido: 0,
                            autorizaDesconto: false,
                        }
                    }));
                }
                if (!isDescontoLinhaRef.current) {
                    setOpenFixarDescontoDialog(false);
                    dispatch(setDescontoFixoTemp(descontoSolicitadoRef.current!));
                    dispatch(persistDescontoFixo(data.uuid));
                }
                setStateLocal(prevState => ({ ...prevState, showLoading: false, showModalDescontoItem: false }));
                addSuccess({ id: "desconto-aplicado-com-sucesso", message: "Desconto aplicado", closeable: true, persist: false, hideDuration: 2000 });
            })
            .catch((err) => {
                if (err.response.data.description === "SemConfiguracaoDesconto") {
                    throwErrorMessage(err);
                } else {
                    addError({ id: "usuario-senha-invalido", message: "Usuário ou senha inválidos", closeable: true, persist: false });
                }
                setStateLocal(prevState => ({ ...prevState, showLoading: false }));
            });

        //eslint-disable-next-line
    };

    const getQuantidadeBrindes = useCallback(() => {
        return getQuantidadeItensBrinde(pedido.itens);
    }, [pedido.itens]);

    const renderItem = useCallback((row: IProdutoRow, index: number, imagens: Array<FichaImagemAssociacao>): JSX.Element => {
        const rowImages = imagens.filter(e => e.uuidProduto === row.produto.uuidProduto);
        if (!row.isTroca) {
            return (
                <ItemRegistraVenda
                    row={row}
                    onChangeQuantidade={onChangeQuantidade}
                    changeDesconto={changeDesconto}
                    onBlurDescontoItem={onBlurDescontoItem}
                    onClickDelete={onClickDelete}
                    saveTempDesconto={saveTempDesconto}
                    toggleTipoDesconto={toggleTipoDesconto}
                    key={`${row.produto.codigoSku}-${index}`}
                    onOpenImage={onOpenImage}
                    imagens={rowImages}
                    disabled={!canEditarPedido}
                    canDescontoItem={canDescontoItem}
                    canBrinde={canBrinde}
                />
            );
        }
        return (
            <ItemRegistraVendaTroca
                row={row}
                onChangeQuantidadeTroca={onChangeQuantidadeTroca}
                changeDescontoTroca={changeDescontoTroca}
                onBlurDescontoItemTroca={() => { }}
                onClickDeleteTroca={onClickDeleteTroca}
                saveTempDescontoTroca={saveTempDesconto}
                toggleTipoDescontoTroca={toggleTipoDescontoTroca}
                key={`ItemRegistraVendaTroca-${index}`}
                imagens={rowImages}
                onOpenImage={onOpenImage}
            />
        );
        //eslint-disable-next-line
    }, [produtos, produtosTroca]);

    return (
        <>
            {trocaState.isVisible &&
                <Backdrop
                    sx={{ color: theme.palette.background.default, zIndex: 100 }}
                    open={trocaState.isVisible}
                >
                </Backdrop>
            }
            <Container
                maxWidth="xl"
                sx={{
                    marginTop: '20px',
                }}>

                <Box
                    maxHeight="xl"
                    sx={{
                        display: 'grid',
                        gridTemplateRows: { md: `50px 50px clamp(200px, calc(100vh - 470px), calc(100vh - 470px)) 110px 50px`, xs: `auto auto 450px auto auto` },
                        gap: '10px',
                    }}>
                    <Grid container spacing={2}>
                        {trocaState.isVisible &&
                            <Box sx={{ backgroundColor: theme.palette.background.default, zIndex: 100, width: '100%', padding: '10px', marginLeft: '9px', fontFamily: 'Work Sans', fontWeight: '600', fontSize: '14px', borderRadius: '10px' }}>
                                <Typography sx={{ color: theme.palette.primary.main, fontSize: '2rem' }}>
                                    Informe o produto a ser devolvido...
                                </Typography>
                            </Box>
                        }

                        {!trocaState.isVisible &&
                            <>
                                <Grid xs={12} sm={6} lg={6}>
                                    <ConsumidorInput
                                        ref={consumidorInputRef}
                                        consumidor={consumidor}
                                        onSelect={(item) => onSelectConsumidor(item)}
                                        disable={!canEditarPedido}
                                    />
                                </Grid>
                                <Grid xs={6} sm={3} lg={3}>
                                    <TextField
                                        fullWidth={true}
                                        id="cpfDescritivo"
                                        label="CPF na nota?"
                                        variant="standard"
                                        disabled={true}
                                        value={(cpfNota?.identificacao && !cpfNota?.nome)
                                            ? mascaraCpfCnpj(cpfNota.identificacao)
                                            : (cpfNota?.identificacao && cpfNota?.nome) ? `${mascaraCpfCnpj(cpfNota.identificacao)} - ${cpfNota.nome}` : ''}
                                        InputLabelProps={{
                                            sx: {
                                                marginLeft: '5px'
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <React.Fragment>
                                                    <h4 className="h4-formatado">(F3)</h4>
                                                    <IconButton sx={{ height: 0, padding: 0, paddingLeft: '5px' }}
                                                        onClick={handleClickOpenDialog}
                                                    >
                                                        <i className="fa-regular fa-file-lines" style={{ color: theme.palette.primary.main }} />
                                                    </IconButton>
                                                </React.Fragment>
                                            )
                                        }}
                                    />
                                    <CpfNota
                                        onClose={handleClickCloseDialog}
                                        open={openDialog}
                                        data={cpfNota}
                                    />
                                </Grid>

                                <Grid xs={6} sm={3} lg={3}>
                                    <Autocomplete
                                        disabled={isEmpty(stateLocal.canaisDeVenda)}
                                        onBlur={onBlurCanalVenda}
                                        value={canalDeVenda}
                                        disablePortal
                                        id="acCanalVenda"
                                        options={filterCanaisVenda(stateLocal.canaisDeVenda, stateLocal.filtroCanalDeVenda)}
                                        getOptionLabel={(option) => option.descritivo}
                                        onInputChange={onInputChangeCanalVendaAc}
                                        filterOptions={(x) => x}
                                        noOptionsText={'Nenhum resultado encontrado'}
                                        isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                                        renderOption={(_, option) => {
                                            return (
                                                <MenuItem
                                                    key={randomUuid()}
                                                    value={option.descritivo}
                                                    onClick={() => onSelectCanalVenda(option)}
                                                >
                                                    <ListItemText primary={option.descritivo} />
                                                    <Tooltip title="Selecione para definir seu canal de venda padrão">
                                                        <Checkbox
                                                            id={`item-${option.descritivo.toLowerCase()}-input`}
                                                            sx={{
                                                                '&.MuiCheckbox-root.Mui-checked': {
                                                                    color: theme.palette.primary.main
                                                                }
                                                            }}
                                                            onClick={() => onSelectCanalVendaPadrao(option)}
                                                            checked={canalVendaPadrao?.uuid === option.uuid}
                                                        />
                                                    </Tooltip>
                                                </MenuItem>
                                            );
                                        }}
                                        renderInput={
                                            (params) => <TextField {...params}
                                                label="Canal de venda"
                                                variant="standard"
                                                inputRef={canalVendaRef}
                                                InputLabelProps={{
                                                    sx: {
                                                        marginLeft: '5px'
                                                    }
                                                }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            <h4 className="h4-formatado">(F10)</h4>
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    )
                                                }}
                                            />}
                                    />
                                </Grid>
                            </>
                        }

                    </Grid>

                    <Grid container spacing={2}>
                        <Grid xs={12} sm={6} lg={6}>
                            <SkuInput
                                ref={skuinputRef}
                                onSelect={onSelectProduto}
                                onSelectCupomTroca={onSelectCupomTroca}
                                permiteCupomTroca={trocaState.isVisible}
                                getOptionLabel={o => `${o.codigoSku}/${o.nome}/${o.cor}/${o.tamanho}`}
                                disabled={!canEditarPedido}
                                porCodigoSx={{
                                    zIndex: trocaState.isVisible ? 100 : 1,
                                    bgcolor: trocaState.isVisible ? theme.palette.background.default : '',
                                }}
                                porProdutoSx={{
                                    zIndex: trocaState.isVisible ? 100 : 1,
                                    bgcolor: trocaState.isVisible ? theme.palette.background.default : '',
                                }}
                                porCupomSx={{
                                    zIndex: trocaState.isVisible ? 100 : 1,
                                    bgcolor: trocaState.isVisible ? theme.palette.background.default : '',
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} lg={6} >
                            <VendedorInput
                                ref={vendedorInputRef}
                                onSelect={onSelectVendedor}
                                vendedor={vendedorPrincipal}
                                disable={!canEditarVendedor}
                            />
                        </Grid>
                    </Grid>

                    <InfiniteScrollVirtuoso
                        data={[...produtos, ...produtosTroca]}
                        renderItem={({ data, index }) => renderItem(data, index, imagens)}
                        heightScale={"clamp(200px, calc(100vh - 470px), calc(100vh - 470px))"}
                        minHeight="200px"
                        fixedHeaderContent={fixedHeaderContent}
                        fixedFooterContent={fixedFooterContent}
                        bgcolor={theme.palette.background.default}
                    />

                    <Footer
                        onClickAvancar={onClickAvancar}
                        onClickCancelar={onClickCancelar}
                        floatingActionsProps={floatingActions}
                        onSwitchOptions={switchOptions}
                        troca={trocaState}
                        isDialogVisible={openFixarDescontoDialog}
                        brinde={stateLocal.brinde}
                        onClickBrinde={clickBrinde}
                    />
                </Box >

                <FixarDescontoDialog
                    open={openFixarDescontoDialog}
                    percentual={percentualTemp}
                    onChangeDesconto={onChangeDescontoFixo}
                    onConfirm={onSaveDescontFixo}
                    onClose={onCloseFixarDescontoDialog}
                    onClear={onClearDescontoFixo}
                />

                {stateLocal.showModalDescontoItem &&
                    <AutorizaDescontoAcrescimo
                        onClose={closeAutorizaDesconto}
                        valorSolicitado={descontoSolicitadoRef}
                        onAutorizaDesconto={handleAutorizaDesconto}
                        tipoDescontoAcrescimoAutorizador={TipoDescontoAcrescimoAutorizador.DESCONTO_ITEM}

                    />
                }
                {stateLocal.showLoading &&
                    <CustomLoading />
                }
                {stateLocal.showModalDescontoNaoAutorizado &&
                    <AutorizaDescontoItemError
                        valorSolicitado={descontoSolicitadoRef}
                        closeModalDescontoItemError={closeAutorizaDesconto}
                        tipoDescontoAcrescimoAutorizador={TipoDescontoAcrescimoAutorizador.DESCONTO_ITEM}
                    />
                }

                <ObservacaoDialog
                    open={openObservacao}
                    onCloseHistoricoDialog={() => setOpenObservacao(false)}
                    getPreviusObs={() => pedido.observacao}
                    dispatchObs={obs => { dispatch(setObservacao(obs)); }}
                />

            </Container >

            <ConsultaEstoque open={openConsultaEstoqueDialog} setOpen={setOpenConsultaEstoqueDialog} />

            <ValePresenteDialog open={openStateValePresenteDialog} setOpen={setOpenStateValePresenteDialog} />

            {preferencias.tabelasPreco && preferencias.tabelasPreco.length > 1 &&
                <TabelaPrecoPreferenciaDialog
                    open={openDialogTabelaPrecoPreferencia}
                    setOpen={setOpenDialogTabelaPrecoPreferencia}
                />}

            {dadosAlterarTabelaPrecoState.showConfirmaExclusao && (
                <ConfirmacaoExcluirSkuDialog
                    open={dadosAlterarTabelaPrecoState.showConfirmaExclusao}
                    dados={dadosAlterarTabelaPrecoState}
                    onConfirm={onConfirmModalSkus}
                />)
            }

            {!!stateLocal.uuidProduto &&
                <CustomProdutoImagensDialog
                    onClose={onCloseImagensProduto}
                    uuidProduto={stateLocal.uuidProduto}
                    imagens={imagens.find(e => e.uuidProduto === stateLocal.uuidProduto) ?? null}
                />
            }
        </>
    );
}
